module.exports = __webpack_public_path__ + "static/media/i_featured_history.6f25f284.svg";